import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Materials from './pages/Materials';
import MaterialDetail from './pages/MaterialDetail';
import Contact from './pages/Contact';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/materialer" element={<Layout><Materials /></Layout>} />
        <Route path="/materialer/:slug" element={<Layout><MaterialDetail /></Layout>} />
        <Route path="/kontakt" element={<Layout><Contact /></Layout>} />
      </Routes>
    </>
  );
}

export default App;
